/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { client } from "./api-client";

export const useGetDeliveryVaultRequests = (data: any) =>
  useQuery<any>({
    queryKey: ["GetDeliveryVaultRequests", data?.operationDate],
    queryFn: () => client(`deliveries/services/vault/requests`, { data }),
  });

export const useCreateBulkDeliveryOrders = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/create/bulk/requests`, {
        data,
        successMessage: "Delivery requests created successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetDeliveriesOrders"] });
    },
  });
};

export const useMoveDeliveryVaultCash = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/move/cash`, {
        data,
        successMessage: "Cash successfully moved for all requests!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveryVaultRequests"] });
    },
  });
};
export const useCreateDeliveryOrder = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/create`, {
        data,
        successMessage: "Request submitted successfully!",
      }),
  });

export const useGetDeliveriesOrders = (data: any) =>
  useQuery({
    queryKey: [
      "GetDeliveriesOrders",
      data?.pageNumber,
      data?.searchCriteria,
      data?.operationDate,
      data?.cashCenterId,
      data?.customerId,
      data?.sourceSPId,
    ],
    queryFn: ({ signal }) =>
      client(`deliveries/services/open/requests`, { data, signal }),
  });

export const useCancelDeliveryOrder = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/cancel/services`, {
        data,
        successMessage: "Selected job(s) cancelled successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveriesOrders"] });
    },
  });
};

export const useAssignDeliveryRoute = () => {
  const queryClient = useQueryClient();
  return useMutation<any>({
    mutationFn: (data: any) =>
      client(`deliveries/services/assign/route`, {
        data,
        successMessage: "Route assigned successfully for selected job(s)!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetDeliveriesOrders"],
      });
    },
  });
};

export const useGetDeliveryDetails = (data: any) =>
  useQuery<any>({
    queryKey: ["GetDeliveryDetails", data?.requestId],
    queryFn: () =>
      client(`deliveries/services/request/details/${data?.requestId}`),
    enabled: Boolean(data?.requestId),
  });

export const useEditGetDeliveryJob = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/edit/request`, {
        data,
        successMessage: "Request edited successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetDeliveryDetails"] });
    },
  });
};

export const useUpdateDeliveryStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/update/request/status`, {
        data,
        successMessage: "Request status updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveryDetails"] });
    },
  });
};

export const useGetDeliveryNewRequests = (data: any) =>
  useQuery<any>({
    queryKey: ["GetDeliveryNewRequests", data?.operationDate],
    queryFn: () => client(`deliveries/services/new/requests`, { data }),
  });

export const useApproveDeliveries = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/approve`, {
        data,
        successMessage: "Selected requests accepted successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveryNewRequests"] });
    },
  });
};

export const useGetDeliveryCashierRequests = (data: any) =>
  useQuery<any>({
    queryKey: ["GetDeliveryCashierRequests", data?.operationDate],
    queryFn: () =>
      client(`deliveries/services/packing/cashier/assignment/requests`, {
        data,
      }),
  });

export const useAssignCashierRequests = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/assign/packing/cashier`, {
        data,
        successMessage: "Cashier assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveryCashierRequests"] });
      queryClient.invalidateQueries({ queryKey: ["GetDeliveryCashiersLoad"] });
    },
  });
};

export const useGetDeliveryProcessingCashierRequests = (data: any) =>
  useQuery<any>({
    queryKey: ["GetDeliveryProcessingCashierRequests", data?.operationDate],
    queryFn: () =>
      client(`deliveries/services/processing/area/requests`, {
        data,
      }),
  });

export const useAssignProcessingCashierRequests = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/assign/cash/processing/cashier`, {
        data,
        successMessage: "Cashier assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({
        queryKey: ["GetDeliveryProcessingCashierRequests"],
      });
      queryClient.invalidateQueries({ queryKey: ["GetCashierLoads"] });
    },
  });
};

export const useGetDeliveryPrepAreaRequests = (data: any) =>
  useQuery<any>({
    queryKey: ["GetDeliveryPrepAreaRequests", data?.operationDate],
    queryFn: () =>
      client(`deliveries/services/prep/area/requests`, {
        data,
      }),
  });

export const useAcceptCashPrepArea = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/accept/cash`, {
        data,
        successMessage: "Cash accepted successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveryPrepAreaRequests"] });
    },
  });
};

export const useGetDeliveriesVaultRequests = (data: any) =>
  useQuery<any>({
    queryKey: [
      "GetDeliveriesVaultRequests",
      data?.operationDate,
      data?.customerId,
    ],
    queryFn: () =>
      client(`deliveries/services/vault/handover/requests`, {
        data,
      }),
  });

export const useDeliveryAddCashToVault = () => {
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/add/cash/vault`, {
        data,
        successMessage: "Cash handover to vault successfully!",
      }),
    onSuccess: () => {
      "GetDeliveriesVaultRequests";
    },
  });
};

export const useAssignBagSeals = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/bulk/bags/assignment`, {
        data,
        successMessage: "Bag Seal Assigned successfully!",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetDeliveriesOrders"] });
    },
  });
};

export const useGetSingCurrencyTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/download/single/currency/template`, { data }),
  });

export const useGetMultipleCurrencyTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/download/multiple/currency/template`, {
        data,
      }),
  });

export const useGetCoinsTemplate = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/download/coins/template`, { data }),
  });

export const useAssignDeliveryBags = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/assign/consignments`, { data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GetDeliveryDetails"] });
    },
  });
};

export const useUpdateDeliveryAfterCompletion = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/update/evhr/request`, {
        data,
        successMessage: "Request updated successfully!",
      }),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: ["GetDeliveryDetails"] });
    },
  });
};

export const useValidateBulkBagsAssignment = () =>
  useMutation({
    mutationFn: (data: any) =>
      client(`deliveries/services/validate/bulk/bags/assignment`, {
        data,
        errorMessage: "Invalid barcodes found.",
      }),
  });
